import React from 'react';
import classnames from 'classnames';
import { flex, row, spaceBetween, centerItems } from 'scy/flex.mod.scss';
import { Body } from 'scy/text';
import { secondary } from 'scy/text/styles.mod.scss';
import padding from 'scy/padding.mod.scss';
import border from 'scy/border.mod.scss';
import { capitalize } from 'shared/utils';

const RoundupRow = ({
  className,
  label,
  isTopCell,
  isBottomCell,
  children,
  showOrgs,
  value
}) => {
  return (
    <div
      className={classnames(flex, row, spaceBetween, centerItems, className, {
        [border.bottomMedium]: !isBottomCell,
        [padding.bottom_sm]: !isBottomCell,
        [padding.top_sm]: !isTopCell
      })}
    >
      {label && (
        <>
          <Body className={classnames(showOrgs ? padding.bottom_sm : '')}>
            {capitalize(label)}
          </Body>
          <Body className={secondary}>{capitalize(value)}</Body>
        </>
      )}
      {typeof children === 'string' ? capitalize(children) : children}
    </div>
  );
};

export default RoundupRow;
